import React from 'react'
import Step from '../../components/Step'
import ButtonSelect from '../../elements/ButtonSelect'
import Resi from '../Resi'
import {fieldName, routeName, enforce} from '../HelpersResi'


const sprinklersLocation = fieldName('sprinklersLocation')

export const rules = {
    [sprinklersLocation]:[]
}


export default () => {
    const navigation = Resi.useNavigation();
    const fields = Resi.useFields();
    const options = Resi.useOptions();


    function onSelected(value:string){
        fields.setValue(sprinklersLocation)(value);
        navigation.goToNext();
    }

    return (
        <Step>
            <h2>Are there sprinklers in the building?</h2>
            <ButtonSelect 
                options={ options.data.product.SPRINKLERS }
                selected={fields.value(sprinklersLocation)}
                colsLg={ 3 }
                colsSm={ 1 }
                callback={ onSelected }
            />
        </Step>
    )
};